// AI Generated Pipe
import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@client/app/services/translate/translate.service';

@Pipe({
    name: 'translateSeoIssue',
    standalone: false,
})
export class TranslateSeoIssuePipe implements PipeTransform {
    private readonly dictionary: { [key: string]: string } = {
        seo_missing_title: 'Missing title',
        seo_duplicate_title: 'Title found on more than one page',
        seo_too_long_url: 'Too long URL',
        seo_missing_h1: 'Missing H1',
        seo_multiple_h1: 'Multiple H1 on page',
        seo_duplicate_h1: 'H1 found on more than one page',
        seo_missing_meta_description: 'Missing META description',
        seo_too_short_meta_description: 'Too short META description',
        seo_too_long_meta_description: 'Too long META description',
        seo_too_many_page_links: 'Too many internal links',
        seo_missing_subheadlines: 'Missing sub headings',
        seo_missing_alt: 'Images missing ALT',
        seo_no_index: 'Pages with - No index',
        seo_no_follow: 'Links with - No follow',
    };

    constructor (private translateService: TranslateService) {}

    transform (word: string): string {
        const translationKey = this.dictionary[word];
        if (translationKey) {
            return this.translateService.getString(translationKey);
        }
        return word;
    }
}
